export default __webpack_public_path__ + "static/media/a1.c50c55c6.png";